import { AGENCY_ORGANIZATION_SEARCH_RESULT, AgencyOrganizationData, AGENCY_ORGANIZATION_TYPE, RESET_AGENCY_FORM, SUBMIT_AGENCY_FORM, SUBMIT_AGENCY_FAILED, EDIT_AGENCY_FORM, CANCEL_EDIT_AGENCY_FORM } from './types';

const initialState = {
  agencyOrganizations: [],
  formValues: {},
  isFormSubmitted: false,
  agencyDetails: {},
  isFormEditable: false
}
export const agencyOrganization = (
  state: AgencyOrganizationData = initialState,
  action: {
    type: string;
    payload?: any;
  }
): AgencyOrganizationData => {
  switch (action.type) {
    case AGENCY_ORGANIZATION_SEARCH_RESULT:
      return { ...state, agencyOrganizations: action.payload, isFormSubmitted: false };
    case AGENCY_ORGANIZATION_TYPE:
      return { ...state, formValues: { ...state.formValues, ['organizationType']: action.payload } };
    case SUBMIT_AGENCY_FORM:
      return {
        ...state,
        agencyDetails: { ...action.payload },
        isFormSubmitted: true,
        isFormEditable: false
      };
    case EDIT_AGENCY_FORM:
      return {
        ...state,
        agencyDetails: { ...action.payload },
        isFormEditable: true,
        isFormSubmitted: false
      };
      case CANCEL_EDIT_AGENCY_FORM:
      return {
        ...state,
        isFormEditable: false,
        isFormSubmitted: true,
      };
    case RESET_AGENCY_FORM:
      return initialState;
    case SUBMIT_AGENCY_FAILED:
      return {
        ...state,
        isFormSubmitted: false,
      };
    default:
      return state;
  }
}


